/* eslint no-template-curly-in-string: 0 */

const defaultCompleteImg = require("../../../../assets/images/default-complete-success.jpg");
const finixLogo = require("../../../../assets/images/visa_mc_logo.png");

export const finix = {
  id: "OCT_FINIX",
  displayName: "Saldo de su Tarjeta de Débito",
  paymentFlow: "oct",
  cssClassPrefix: "bank",
  paywall: {
    tile: {
      displayName: ["Depósito a su Tarjeta de Débito"],
      tagline: ["Reciba los fondos en 30 minutos o menos."],
      description: [
        {
          string: "Utilice su número de tarjeta de débito para recibir",
          type: "div",
        },
        {
          string: "fondos en su cuenta bancaria",
          type: "div"
        }
      ],
    }
  },
  recipientLogin: {
    title: ["Directo al Banco"],
    description: [
      "La información de su tarjeta es procesada de manera segura por Visa y no se envía a ${programName}."
    ],
    errors: {
      400: {
        title: 'Fallo en la Tarjeta',
        message: "Se produjo un error al procesar el pago a su tarjeta. Por favor, inténtelo de nuevo con otra tarjeta o forma de pago.",
      }
    },
    props: {
      acceptedCardTypes: {
        cardTypes: ['visa', 'mastercard'],
        errorMessage: 'Debe usar una tarjeta Visa o Mastercard'
      },
    },
  },
  acceptPayment: {
    flow: 'finix',
    btnLabel: "Aplicar al Saldo de su Tarjeta de Débito",
    description: [
      "Decidió añadir ",
      {
        string: "${payment.amount}",
        transformations: [
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.currency}"
            }
          }
        ],
        props: {
          className: "payment-amount",
        }
      },
      " directamente al saldo de su tarjeta de débito."
    ],
    imgSrc: finixLogo,
    disclaimerHtmlString: null
  },
  paymentComplete: {
    imgSrc: finixLogo,
    initial: {
      description: [
        "¡Éxito! Un pago de ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        " ha sido depositado al saldo de su tarjeta de débito."
      ]
    },
    revisit: {
      description: [
        "Su pago de ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        " fue depositado al saldo de su tarjeta de débito el ",
        {
          string: "${payment.updatedAt}",
          transformations: [
            {
              type: "formatDate"
            }
          ],
          props: {
            className: 'payment-updatedAt'
          }
        },
        "."
      ]
    },
    paymentCompleteButtons: [],
    img: defaultCompleteImg
  }
};

export default finix;
